import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/site";

export default function ClientProject() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    const previous = document.title;
    const robots = document.createElement("meta");
    robots.name = "robots"; robots.content = "noindex, nofollow, noarchive";
    document.head.appendChild(robots);
    setProject(null); setFailed(false);
    api.get(`/projects/${id}`).then(({ data }) => {
      if (active) { setProject(data); document.title = `${data.title} | Click and Grow Digital`; }
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; robots.remove(); document.title = previous; };
  }, [id]);
  return <div className="min-h-screen bg-white text-slate-900">
    <div className="max-w-3xl mx-auto px-6 py-10 sm:py-16">
      <p className="text-xs tracking-widest uppercase text-slate-500">Click and Grow Digital</p>
      {failed ? <div role="alert" className="mt-12"><h1 className="text-2xl font-semibold">Project page unavailable</h1><p className="mt-3 text-slate-500">Please contact your project manager for the current link.</p></div> : !project ? <p role="status" className="mt-12 text-slate-500">Loading project…</p> : <>
        <header className="mt-12 border-b pb-8">
          {project.client && <p className="text-slate-500 mb-3">Prepared for {project.client}</p>}
          <h1 className="text-3xl sm:text-4xl font-semibold break-words">{project.title}</h1>
          <p className="mt-4 text-xs text-slate-400">Updated {new Date(project.updated_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}</p>
        </header>
        {project.text && <div className="whitespace-pre-wrap break-words leading-8 py-8">{project.text}</div>}
        <div className="space-y-6 mt-6">{project.photos.map((photo, i) => <img key={i} src={photo} alt={`${project.title} — photo ${i + 1}`} className="w-full h-auto rounded-lg" loading="lazy" />)}</div>
      </>}
    </div>
  </div>;
}
